// extracted by mini-css-extract-plugin
export default {"root":"Select_root__f+C3j","select":"Select_select__OlUEn","label":"Select_label__dwCt3"};